/* unplugin-vue-components disabled */import script from "./groupSchedule.vue?vue&type=script&lang=ts&setup=true"
export * from "./groupSchedule.vue?vue&type=script&lang=ts&setup=true"

export default script